'use client'

import { useLayoutEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'
import { isNotebookPathname } from './notebook-route-entry'
import { purgeAllNotebookRoots, purgeOrphanNotebookRoots } from './notebook-route-root'
import { syncNotebookRouteDom } from './notebook-route-activation'
import { nbLog } from './notebook-debug'

let exitPurgeRaf = 0

/**
 * Global pathname watcher — purge orphan notebook DOM on exit from /notebook/*.
 */
export function NotebookRouteEntryTracker() {
  const pathname = usePathname()
  const pathnameRef = useRef(pathname)
  pathnameRef.current = pathname

  useLayoutEffect(() => {
    const onPageShow = (event) => {
      if (!event.persisted) return
      if (!isNotebookPathname(pathnameRef.current)) {
        purgeAllNotebookRoots()
      }
    }
    window.addEventListener('pageshow', onPageShow)
    return () => window.removeEventListener('pageshow', onPageShow)
  }, [])

  useLayoutEffect(() => {
    if (exitPurgeRaf) {
      cancelAnimationFrame(exitPurgeRaf)
      exitPurgeRaf = 0
    }

    if (isNotebookPathname(pathname)) {
      purgeOrphanNotebookRoots()
      syncNotebookRouteDom()
      const raf = requestAnimationFrame(() => {
        if (isNotebookPathname(pathnameRef.current)) {
          purgeOrphanNotebookRoots()
          syncNotebookRouteDom()
        }
      })
      return () => cancelAnimationFrame(raf)
    }

    purgeAllNotebookRoots()

    exitPurgeRaf = requestAnimationFrame(() => {
      exitPurgeRaf = 0
      if (isNotebookPathname(pathnameRef.current)) {
        nbLog('nav', 'exit purge skipped — already on notebook route')
        return
      }
      purgeAllNotebookRoots()
    })

    return () => {
      if (exitPurgeRaf) {
        cancelAnimationFrame(exitPurgeRaf)
        exitPurgeRaf = 0
      }
    }
  }, [pathname])

  return null
}
